import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(rawNum: any, args?: any): any {

    if (!rawNum) return rawNum;

    rawNum = rawNum.charAt(0) != 0 ? "0" + rawNum : "" + rawNum;
    
    // TODO 전화번호 formmater 개발

    const areaCodeStr = rawNum.slice(0,3);
    const midSectionStr = rawNum.slice(3,7);
    const lastSectionStr = rawNum.slice(7,11);

    return `(${areaCodeStr})${midSectionStr}-${lastSectionStr}`;
  }
}
